import { useLoadScript } from '@react-google-maps/api'

export const GOOGLE_PLACES_API_KEY = 'AIzaSyBjMaDVfgY7BnO9B2NvsHkxCITSmmvh8eU'
export const GOOGLE_MAPS_SCRIPT_ID = 'google-maps-sdk'
export const GOOGLE_MAP_LIBRARIES: Array<'places'> = ['places']

export const useGoogleMapsPlaces = (): ReturnType<typeof useLoadScript> => {
  return useLoadScript({
    id: GOOGLE_MAPS_SCRIPT_ID,
    googleMapsApiKey: GOOGLE_PLACES_API_KEY,
    libraries: GOOGLE_MAP_LIBRARIES
  })
}
